export default "__VITE_ASSET__Ob341MAy__";